<template>
  <div class="display-page-root">
    <div class="first-box">
      <div class="content">
        <div class="logo-box">
          <img src="../../assets/displayPage/logo.png" alt="" class="logo" />
        </div>
        <div class="first-font-box">
          <div>楼域业主直租平台</div>
          <div class="first-font-box-sub-font">
            公平，公正，高效的房地产直租市场
          </div>
        </div>
      </div>
    </div>
    <secondPage></secondPage>
    <thirdPage></thirdPage>
    <fourthPage></fourthPage>
    <custom-footer></custom-footer>
  </div>
</template>

<script>
import secondPage from "./secondPage.vue";
import thirdPage from "./thirdPage.vue";
import fourthPage from "./fourthPage.vue";
import customFooter from "./footer.vue";

export default {
  data() {
    return {
      userName: "",
      location: "成都",
      isLogin: false,
      userInfo: null,
    };
  },
  components: {
    secondPage,
    thirdPage,
    fourthPage,
    customFooter,
  },
  computed: {},
  watch: {},

  methods: {},
  mounted() {
    console.log("调用了吗");
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  },
};
</script>

<style lang="scss" scoped>
.display-page-root {
  width: 100%;
  height: 100%;
  .first-box {
    width: 100%;
    height: 480px;
    background: url("../../assets/displayPage/first.png") no-repeat;
    background-size: cover;
    .logo-box {
      padding-top: 32px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .logo {
        width: 155px;
        height: 59px;
        cursor: pointer;
      }
    }
    .first-font-box {
      margin-top: 100px;
      font-family: Source Han Sans, Source Han Sans;
      font-weight: 700;
      font-size: 68px;
      color: #ffffff;
      line-height: 98px;
      .first-font-box-sub-font {
        font-family: Source Han Sans, Source Han Sans;
        font-weight: 400;
        font-size: 52px;
        color: #ffffff;
        line-height: 75px;
        margin-top: 12px;
      }
    }
  }
}

.content {
  width: 1200px;
  margin: 0 auto;
  min-width: 1200px;
}
</style>
